import React from 'react';
import { Error } from '../../components/icons';
import {
  ErrorIconContainer,
  ErrorMessageContainer,
  ErrorMessageText
} from './styled';

const OtpErrorMessage = ({ errorMessage }: { errorMessage: string }) => (
  <ErrorMessageContainer>
    <ErrorIconContainer>
      <Error />
    </ErrorIconContainer>
    <ErrorMessageText>{errorMessage}</ErrorMessageText>
  </ErrorMessageContainer>
);

export default OtpErrorMessage;
